import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodos() {
        let url = `${api}/admin/jobs`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterLogs(jobId) {
        let url = `${api}/admin/jobs/${jobId}/logs`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    reiniciarJobs() {
        let url = `${api}/admin/jobs/reiniciar`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }

    // obterDashboard(id) {
    //     return axiosJwt.get(`${api}/fornecedores/${id}/dashboard`)
    //         .then((response) => {
    //             return response.data
    //         }).catch((error) => {
    //             return errorHandler(error)
    //         })
    // },

    // obterDados(id) {
    //     let url = `${api}/fornecedores/${id}/dadoscadastrais`
    //     return axiosJwt.get(url)
    //         .then((response) => {
    //             return response.data
    //         }).catch((error) => {
    //             return errorHandler(error)
    //         })
    // },

    // obterPagamentosRm(id, filtro) {
    //     let url = `${api}/fornecedores/${id}/pagamentos?dataInicial=${filtro.dataInicial}&dataFinal=${filtro.dataFinal}`
    //     return axiosJwt.get(url)
    //         .then((response) => {
    //             return response.data
    //         }).catch((error) => {
    //             return errorHandler(error)
    //         })
    // },

    // exportarPagamentos(id, exportacao) {
    //     let url = `${api}/fornecedores/${id}/pagamentos/exportar?dataInicial=${exportacao.dataInicial}
    //     &dataFinal=${exportacao.dataFinal}&status=${exportacao.status}&tipo=${exportacao.tipo}`
    //     return axiosJwt.get(url, {
    //         responseType: 'blob'
    //     }).then((response) => {
    //         return response.data
    //     }).catch((error) => {
    //         return errorHandler(error)
    //     })
    // },

    // obterDirf(id, ano) {
    //     let url = `${api}/fornecedores/${id}/dirf/${ano}`
    //     return axiosJwt.get(url)
    //         .then((response) => {
    //             return response.data
    //         }).catch((error) => {
    //             return errorHandler(error)
    //         })
    // },

    // obterRendimentos(id, fornecedorId) {
    //     let url = `${api}/fornecedores/${fornecedorId}/dirf/${id}/rendimentos`
    //     return axiosJwt.get(url, {
    //         responseType: 'blob'
    //     }).then((response) => {
    //         return response.data
    //     }).catch((error) => {
    //         return errorHandler(error)
    //     })
    // },

    // obterPagamentos(id, fornecedorId) {
    //     let url = `${api}/fornecedores/${fornecedorId}/dirf/${id}/pagamentos`
    //     return axiosJwt.get(url, {
    //         responseType: 'blob'
    //     }).then((response) => {
    //         return response.data
    //     }).catch((error) => {
    //         return errorHandler(error)
    //     })
    // },

    // obterContratos(id) {
    //     let url = `${api}/fornecedores/${id}/contratos`
    //     return axiosJwt.get(url)
    //         .then((response) => {
    //             return response.data
    //         }).catch((error) => {
    //             return errorHandler(error)
    //         })
    // },

    // obterCertidoes(id) {
    //     let url = `${api}/fornecedores/${id}/certidoes`
    //     return axiosJwt.get(url)
    //         .then((response) => {
    //             return response.data
    //         }).catch((error) => {
    //             return errorHandler(error)
    //         })
    // }
}
